import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import LocationSchedule from "../../../_components/steps/LocationSchedule";
import ContactInfo from "../../../_components/steps/ContactInfo";
import ViolationInfo from "../../../_components/steps/ViolationInfo";
import VehicleInfos from "../../../_components/steps/VehicleInfos";

import { useForm } from "react-hook-form";
import Cookies from "universal-cookie";
import { useParams, useNavigate } from "react-router-dom";
import { utilities } from "@/_helpers";
import { connect } from "react-redux";
import AddressInfo from "../../../_components/steps/AddressInfo";

import {
  enrolleeUpdate,
  clientUpdate,
  registerEnrollee,
  loadEnrollee,
  saveEnrollee,
  clientProfiles,
} from "../../../_redux/actions/enrolleeActions";
import {
  saveNewVehicle,
  loadVehicle,
} from "../../../_redux/actions/vehicleActions";
import { useToaster } from "../../../_components/toaster/MuiToasterProvider";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled, useTheme } from "@mui/material/styles";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import useMediaQuery from "@mui/material/useMediaQuery";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WarningIcon from "@mui/icons-material/Warning";
import moment from "moment-timezone";
import { RingLoader } from "@/_components";
import {
  loadAppointments,
  createAppointment,
  loadLocation,
} from "../../../_redux/actions/appointmentActions";
import ReferralModal from "../../../_components/steps/modal/ReferralModal";
import CarIcon from "../../../_images/Car_Side.svg";
import { LifeSafer, Monitech } from "../../../_helpers/BrandConstants";
import StateId from "../../../_components/steps/StateId";
import MyAccount from "../../../_components/steps/MyAccount";
import { enrolleeService } from "@/_services";
import { updateProfile } from "../../../_api/profileApi";
import { resetProfilePassword, getUser } from "../../../_api/usersApi";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

const LOCATION_VIOLATION_DRAFT_KEY = "locationViolationDraft";
const LOCATION_PROGRAM_INFO_COMPLETED_KEY =
  "locationProgramInfoCompleted";
const LOCATION_WELCOME_ENTRY_KEY = "locationWelcomeEntry";
import ContinueButton from "../../../_components/steps/ContinueButton";

const hasUsableEnrollmentCode = (enrollmentCodeData) => {
  const enrollmentCodeId =
    enrollmentCodeData?.enrollmentCodeId ||
    enrollmentCodeData?.EnrollmentCodeId ||
    enrollmentCodeData?.EnrollmentCodeID;

  return (
    Boolean(enrollmentCodeId) &&
    !utilities.isMissingOrDefaultEnrollmentCode(enrollmentCodeData)
  );
};

const LocationStory = ({
  enrolleeUpdate,
  clientUpdate,
  registerEnrollee,
  saveEnrollee,
  isLoaded,
  activeStep,
  setActiveStep,
  loadEnrollee,
  hasSetInitialStep,
  saveNewVehicle,
  loadVehicle,
  clientProfiles,
  createAppointment,
  loadAppointments,
  loadLocation,
}) => {
  const cookies = new Cookies();
  const toast = useToaster();
  const { t } = useTranslation();
  let shouldSkipNextStep = false;

  const STEPS = {
    DEVICE: "DEVICE",
    LOCATION_MAP: "LOCATION_MAP",
    LOCATION_ZIP: "LOCATION_ZIP",
    // PRICING: "PRICING",
    DATE_TIME: "DATE_TIME",
    SCHEDULE_NOW: "SCHEDULE_NOW",
  };

  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  // const [activeStep, setActiveStep] = useState(0);

  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const enrolleeClientId = enrolleeUser?.clientId || enrolleeUser?.ClientId;
  const enrolleeUserId =
    enrolleeUser?.userId || enrolleeUser?.userID || enrolleeUser?.UserId;
  const enrolleeVehicleId = enrolleeUser?.vehicleId || enrolleeUser?.vehicleID;
  const enrolleeDeviceType = enrolleeUser?.deviceType;
  const isPamDevice =
    enrolleeUser?.clientTypeId === 5 ||
    enrolleeDeviceType === "PAM" ||
    enrolleeDeviceType?.toLowerCase() === "portable";
  const googleMapDataSession = JSON.parse(
    sessionStorage.getItem("googleMapData"),
  );
  // let enrolleeDataArray = useRef([]);

  const [flagDevice, setFlagDevice] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [pereferedContact, setPreferedContact] = useState(
    enrolleeUser?.contactPreference || "Phone",
  );
  const [userData, setUserData] = useState(null);
  const [user, setUser] = useState(null);

  const jwtTokenData = cookies.get("lifesaferEnrollment");
  // const PendingAppointment = cookies.get("PendingAppointment");
  const { storyName } = useParams();
  const EnrollCookieData = cookies.get("EnrollNow") || {};
  const [deviceLocationType, setDeviceLocationType] = useState(() => {
    if (!enrolleeUser?.deviceSelectionConfirmed) {
      return undefined;
    }
    return utilities.deviceInfo(enrolleeUser?.deviceType)?.deviceType;
  });
  const [referralModal, setReferralModal] = useState(false);
  const [flagClickReset, setFlagClickReset] = useState(false);
  const enrollmentCode = cookies.get("lsEnrollmentCode");
  const [deviceCheck, setDeviceCheck] = useState(() =>
    enrollmentCode?.deviceTypes ? enrollmentCode.deviceTypes.split(",") : [],
  );


  const {
    UTM_source,
    UTM_medium,
    UTM_campaign,
    GA_clientid,
    gclid,
    UserAgent,
    IPAddress,
    wbraid,
    gbraid,
    fbclid,
    fbp,
    ttclid,
    rdt_cid,
    DeviceType,
    Page: rawPage,
    URL,
    LocationId,
    LocationID,
    Story,
  } = EnrollCookieData;
  const locationIdFromCookie = LocationId || LocationID;
  const [locationWelcomeEntry] = useState(() => {
    const storedEntry = sessionStorage.getItem(LOCATION_WELCOME_ENTRY_KEY);

    if (storedEntry) {
      try {
        return JSON.parse(storedEntry);
      } catch (error) {
        console.error("Failed to parse Location welcome entry", error);
      }
    }

    const initialEntry = {
      eligible: Boolean(
        Story?.toLowerCase() === "location" && locationIdFromCookie,
      ),
      locationId: locationIdFromCookie
        ? String(locationIdFromCookie)
        : null,
      consumed: false,
    };
    sessionStorage.setItem(
      LOCATION_WELCOME_ENTRY_KEY,
      JSON.stringify(initialEntry),
    );
    return initialEntry;
  });
  let clientSaveResponse = null;
  const navigate = useNavigate();
  const theme = useTheme();
  const [googleMapData, setGoogleMapData] = useState(googleMapDataSession);
  const Page = rawPage?.substring(0, 150) || "";
  const isAbove1024 = useMediaQuery(theme.breakpoints.up(1024));
  const [toastTimer, setToastTimer] = useState(null);
  const [showToastOverlay, setShowToastOverlay] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [stepSchedule, setStepSchedule] = useState(() =>
    sessionStorage.getItem("forceLocationZipAfterVehicle") === "true" &&
    String(enrolleeUser?.step || enrolleeUser?.Step || "").toLowerCase() !==
      "vehicle"
      ? STEPS.LOCATION_ZIP
      : STEPS.SCHEDULE_NOW,
  );
  const [deviceChangeModalOpen, setDeviceChangeModalOpen] = useState(false);
  const [pendingDeviceReschedule, setPendingDeviceReschedule] = useState(null);
  const [, forceSessionSync] = useState(0);
  const enrollmentCodeData = cookies.get("lsEnrollmentCode");
  const [isPam, setIsPam] = useState(enrolleeUser?.clientTypeId === 5);
  const [vehicleReadyForLocation, setVehicleReadyForLocation] = useState(
    () => sessionStorage.getItem("locationVehicleConfirmed") === "true",
  );
  const [resumeStateInfoAfterVehicle, setResumeStateInfoAfterVehicle] =
    useState(
      () =>
        sessionStorage.getItem("locationResumeStateInfoAfterVehicle") ===
        "true",
    );
  const [, setHasCompletedLocationProgramInfo] = useState(
    () =>
      sessionStorage.getItem(LOCATION_PROGRAM_INFO_COMPLETED_KEY) === "true",
  );
  const hasResolvedLocationProgramInfo = hasUsableEnrollmentCode(
    enrollmentCodeData,
  );
  const [isEnrolleeLoadNeeded, setIsEnrolleeLoadNeeded] = useState(false);
  const [appointmentData, setAppointmentData] = useState(null);
  const isHandlingToastEndRef = useRef(false);
  const endToastIdRef = useRef(null);
  const startToastIdRef = useRef(null);
  const hasAppointmentRef = useRef(false);
  const hasHandledCookieLocationStepRef = useRef(false);
  const hasDismissedLocationWelcomeRef = useRef(false);
  const [location, setLocation] = useState(null);
  const [showWelcomeStep, setShowWelcomeStep] = useState(
    Boolean(locationWelcomeEntry?.eligible && !locationWelcomeEntry?.consumed),
  );
  const locationToastSnackbarSx = useMemo(
    () => ({
      top: {
        xs: "32px !important",
        xl: "58px !important",
      },
    }),
    [],
  );
  const StyledWalkingIcon = styled(DirectionsWalkIcon)({
    fontSize: isAbove1024 ? 24 : 20,
    marginTop: 2.6,
  });
  const [hasAppointment, setHasAppointment] = useState(false);
  const persistedLocationStep =
    enrolleeUser?.step || enrolleeUser?.Step || null;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const shouldShowLocationWelcome = activeStep === 0 && showWelcomeStep;
  const resolvedLocationDeviceType =
    deviceLocationType || DeviceType || enrolleeDeviceType;
  const normalizedLocationDeviceType = String(
    resolvedLocationDeviceType || "",
  ).toLowerCase();
  const isPamForLocation =
    isPam ||
    (resolvedLocationDeviceType
      ? ["pam", "portable"].includes(normalizedLocationDeviceType)
      : enrolleeUser?.clientTypeId === 5);
  const hasActiveLocationReservation = hasExistingLocationReservation();

  const locationStepIndexMap = {
    Schedule: 0,
    Contact: 1,
    Violation: 2,
    Vehicle: 3,
    StateId: 4,
    Address: 5,
    MyAccount: 6,
  };

  const resolveClientDeviceType = (clientTypeId) => {
    if (clientTypeId === 5) return "Portable";
    if (clientTypeId === 6) return "Speed";
    if (clientTypeId === 1) return "Interlock";
    return null;
  };

  const resolveClientTypeId = (deviceType) => {
    if (deviceType === "Portable") return 5;
    if (deviceType === "Speed") return 6;
    if (deviceType === "Interlock") return 1;
    return null;
  };

  const resolveDeviceTypeFromServiceId = (serviceID) => {
    if (serviceID === 290) return "Portable";
    if (serviceID === 396) return "Speed";
    if (serviceID === 1) return "Interlock";
    return null;
  };

  function getPendingAppointmentData() {
    const pendingAppointment = cookies.get("PendingAppointment");
    if (!pendingAppointment) return null;
    if (typeof pendingAppointment === "string") {
      try {
        return JSON.parse(pendingAppointment);
      } catch (error) {
        console.error("Failed to parse pending appointment cookie", error);
        return null;
      }
    }
    return pendingAppointment;
  }

  function hasReservedPendingLocationAppointment(
    pendingAppointment = getPendingAppointmentData(),
  ) {
    return Boolean(
      pendingAppointment?.beginDT &&
        (pendingAppointment?.locationID || pendingAppointment?.locationId),
    );
  }

  function hasExistingLocationReservation() {
    if (
      hasReservedPendingLocationAppointment() ||
      hasAppointmentRef.current ||
      hasAppointment ||
      (Array.isArray(appointmentData) && appointmentData.length > 0)
    ) {
      return true;
    }

    try {
      return Boolean(JSON.parse(sessionStorage.getItem("appointmentData")));
    } catch (error) {
      console.error("Failed to parse appointment data", error);
      return false;
    }
  }

  const syncLocationClientProfiles = (stateInfo, clientTypeId) => {
    try {
      const storedProfiles =
        JSON.parse(sessionStorage.getItem("clientProfiles")) || userData || [];

      if (!Array.isArray(storedProfiles) || storedProfiles.length === 0) return;

      const updatedProfiles = storedProfiles.map((profile, index) =>
        index === 0
          ? {
              ...profile,
              convStateRegionID: stateInfo?.ConvictionStateID,
              convCountyRegionID: stateInfo?.ConvictionCountyID,
              programType: stateInfo?.programType,
              contractEnd: stateInfo?.contractEnd,
              protPlan: stateInfo?.protPlan,
              ...(clientTypeId && {
                clientTypeId,
                clientTypeID: clientTypeId,
              }),
            }
          : profile,
      );

      sessionStorage.setItem(
        "clientProfiles",
        JSON.stringify(updatedProfiles),
      );
      setUserData(updatedProfiles);
    } catch (error) {
      console.error("Failed to sync client profile session", error);
    }
  };

  const normalizeDeviceTypeCandidate = (deviceCandidate) => {
    if (
      deviceCandidate === null ||
      deviceCandidate === undefined ||
      deviceCandidate === ""
    ) {
      return null;
    }

    if (typeof deviceCandidate === "number") {
      return resolveClientDeviceType(deviceCandidate);
    }

    if (typeof deviceCandidate !== "string") {
      return null;
    }

    const normalizedValue = deviceCandidate.trim().toLowerCase();
    const supportedDeviceTypes = [
      "iid",
      "interlock",
      "pam",
      "portable",
      "speed",
      "speedv",
      "isa",
    ];

    if (!supportedDeviceTypes.includes(normalizedValue)) {
      return null;
    }

    return utilities.deviceInfo(normalizedValue)?.deviceType || null;
  };

  const resolveDeviceTypeValue = (...deviceCandidates) => {
    for (const deviceCandidate of deviceCandidates) {
      const normalizedDeviceType =
        normalizeDeviceTypeCandidate(deviceCandidate);
      if (normalizedDeviceType) {
        return normalizedDeviceType;
      }
    }

    return (
      resolveClientDeviceType(enrolleeUser?.clientTypeId) ||
      normalizeDeviceTypeCandidate(DeviceType) ||
      null
    );
  };

  useEffect(() => {
    if (enrollmentCode?.deviceTypes) {
      setDeviceCheck(enrollmentCode.deviceTypes.split(","));
      return;
    }
    setDeviceCheck([]);
  }, [enrollmentCode?.deviceTypes]);

  useEffect(() => {
    hasAppointmentRef.current = hasAppointment;
  }, [hasAppointment]);

  const getLocations = async (locationId) => {
    let locationRes = await loadLocation(locationId);
    if (!hasDismissedLocationWelcomeRef.current) {
      setShowWelcomeStep(
        Boolean(locationRes && Object.keys(locationRes).length > 0),
      );
    }
    setLocation(locationRes);
  };

  const dismissLocationWelcome = () => {
    hasDismissedLocationWelcomeRef.current = true;
    setShowWelcomeStep(false);
    sessionStorage.setItem(
      LOCATION_WELCOME_ENTRY_KEY,
      JSON.stringify({
        ...locationWelcomeEntry,
        consumed: true,
      }),
    );
  };

  useEffect(() => {
    if (
      locationWelcomeEntry?.eligible &&
      !locationWelcomeEntry?.consumed &&
      locationWelcomeEntry?.locationId
    ) {
      getLocations(locationWelcomeEntry.locationId);
    } else {
      setShowWelcomeStep(false);
    }
  }, []);

  const StyledCarIcon = styled("img")({
    height: 30,
    width: 30,
    marginTop: 8,
    filter: "invert(1)",
  });

  const refreshAppointments = async () => {
    const clientId = enrolleeUser?.clientId || enrolleeUser?.ClientId;
    if (!clientId) return false;

    try {
      const x = await loadAppointments(clientId);
      const appointments = Array.isArray(x)
        ? x
        : Array.isArray(x?.appointments)
          ? x.appointments
          : Array.isArray(x?.data)
            ? x.data
            : x?.appointmentID || x?.appointmentId
              ? [x]
              : [];
      setAppointmentData(appointments);

      const appointmentExists = appointments.length > 0;
      setHasAppointment(appointmentExists);
      hasAppointmentRef.current = appointmentExists;

      if (appointmentExists) {
        sessionStorage.setItem(
          "appointmentData",
          JSON.stringify(appointments[0]),
        );
      } else {
        sessionStorage.removeItem("appointmentData");
      }

      return appointmentExists;
    } catch (e) {
      console.log("error", e);
      return null;
    }
  };

  useEffect(() => {
    if ((enrolleeUser?.clientId || enrolleeUser?.ClientId) && activeStep > 4) {
      refreshAppointments();
    }
  }, [activeStep]);

  useEffect(() => {
    if ((enrolleeUser?.userId || enrolleeUser?.userID) && activeStep > 4) {
      getUser(enrolleeUser?.userId || enrolleeUser?.userID)
        .then((x) => {
          setUser(x);
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  }, [activeStep]);

  useEffect(() => {
    const hasPendingAppointment = hasExistingLocationReservation();
    const hasPendingLocationSchedule =
      hasPendingAppointment &&
      Boolean(cookies.get("PendingLocationSchedule"));

    if (!hasPendingAppointment && activeStep > 3 && activeStep < 6) {
      setActiveStep(0);
      setStepSchedule("SCHEDULE_NOW");
      return;
    }

    const persistedStepIndex = locationStepIndexMap[persistedLocationStep];

    if (hasPendingAppointment || hasPendingLocationSchedule) {
      hasHandledCookieLocationStepRef.current = true;
      return;
    }

    if (activeStep === persistedStepIndex) {
      hasHandledCookieLocationStepRef.current = true;
      return;
    }

    if (
      activeStep <= 1 ||
      (activeStep === locationStepIndexMap.Violation &&
        !hasResolvedLocationProgramInfo) ||
      activeStep === locationStepIndexMap.Vehicle ||
      hasHandledCookieLocationStepRef.current
    ) {
      return;
    }
    hasHandledCookieLocationStepRef.current = false;
    setActiveStep(0);
    setStepSchedule("SCHEDULE_NOW");
  }, [activeStep, persistedLocationStep, setActiveStep, setStepSchedule]);

  useEffect(() => {
    if (activeStep === locationStepIndexMap.Vehicle) {
      sessionStorage.removeItem("forceLocationZipAfterVehicle");
      setStepSchedule(STEPS.SCHEDULE_NOW);
    }
  }, [activeStep]);

  useEffect(() => {
    if (
      (enrolleeUserId || enrolleeClientId) &&
      activeStep > 3 &&
      !isPamDevice
    ) {
      loadVehicle(enrolleeClientId, enrolleeUserId)
        .then((vehicleData) => {
          const vehicles = Array.isArray(vehicleData) ? vehicleData : [];

          const latestVehicle = vehicles[vehicles.length - 1];

          const vehicleWithoutUserIdData = { ...latestVehicle };
          delete vehicleWithoutUserIdData.userId;

          const shouldSyncVehicleToSession =
            enrolleeVehicleId !== vehicleWithoutUserIdData?.vehicleId ||
            !enrolleeUser?.make ||
            !enrolleeUser?.model ||
            enrolleeUser?.vehYear == null ||
            enrolleeUser?.vehYear === 0;

          if (shouldSyncVehicleToSession) {
            sessionStorage.setItem(
              "enrolleeUser",
              JSON.stringify({
                ...enrolleeUser,
                ...vehicleWithoutUserIdData,
              }),
            );
            forceSessionSync((x) => x + 1);
          }
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  }, [
    activeStep,
    enrolleeClientId,
    enrolleeUserId,
    enrolleeVehicleId,
    isPamDevice,
    enrolleeUser?.make,
    enrolleeUser?.model,
    enrolleeUser?.vehYear,
    loadVehicle,
    setActiveStep,
  ]);

  // const startLocationToastFlow = (initialSeconds = 600) => {
  //   let seconds = initialSeconds;

  //   const toastId = toast.success(
  //     <LocationStartToast seconds={seconds} />,
  //     null,
  //     true,
  //     <AccessTimeIcon />,
  //     { backgroundColor: "#e3f2fd", color: "#0d47a1" },
  //   );

  //   const interval = setInterval(() => {
  //     seconds -= 1;
  //     toast.update(toastId, <LocationStartToast seconds={seconds} />);
  //     if (seconds <= 0) clearInterval(interval);
  //   }, 1000);

  //   const timeout = setTimeout(() => {
  //     toast.warning(
  //       <LocationEndToast onClick={handleLocationToastEndClick} />,
  //       null,
  //       true,
  //       <WarningIcon />,
  //       { backgroundColor: "#fff8e1", color: "#6d4c41" },
  //     );
  //   }, seconds * 1000);

  //   setToastTimer({ interval, timeout });
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);

  const startLocationToastFlow = (initialSeconds = 600) => {
    let seconds = initialSeconds;

    const toastId = toast.success(
      <LocationStartToast seconds={seconds} />,
      null,
      true,
      <AccessTimeIcon />,
      { backgroundColor: "#e3f2fd", color: "#0d47a1" },
      locationToastSnackbarSx,
      true,
    );
    startToastIdRef.current = toastId;

    const interval = setInterval(() => {
      seconds -= 1;
      toast.update(toastId, <LocationStartToast seconds={seconds} />);
      if (seconds <= 0) clearInterval(interval);
    }, 1000);

    const preEndTimeout = setTimeout(
      () => {
        refreshAppointments();
      },
      Math.max(initialSeconds - 60, 0) * 1000,
    );

    const timeout = setTimeout(() => {
      refreshAppointments().finally(() => {
        if (startToastIdRef.current) {
          toast.dismiss(startToastIdRef.current);
          startToastIdRef.current = null;
        }
        setDeviceChangeModalOpen(false);
        setPendingDeviceReschedule(null);
        const endToastId = toast.warning(
          <LocationEndToast
            onClick={() => handleLocationToastEndClick(endToastId)}
          />,
          null,
          true,
          <WarningIcon />,
          { backgroundColor: "#fff8e1", color: "#6d4c41" },
          locationToastSnackbarSx,
          true,
        );
        endToastIdRef.current = endToastId;
        setShowToastOverlay(true);
        sessionStorage.setItem("locationToastOverlay", "1");
      });
    }, initialSeconds * 1000);

    setToastTimer({ interval, preEndTimeout, timeout });
  };

  // const startLocationToastFlow = (initialSeconds = 600) => {
  //   let seconds = initialSeconds;

  //   const toastId = toast.success(
  //     <LocationStartToast seconds={seconds} />,
  //     null,
  //     true,
  //     <AccessTimeIcon />,
  //     { backgroundColor: "#e3f2fd", color: "#0d47a1" },
  //   );

  //   const interval = setInterval(() => {
  //     seconds -= 1;
  //     toast.update(toastId, <LocationStartToast seconds={seconds} />);

  //     if (seconds <= 0) {
  //       clearInterval(interval);
  //     }
  //   }, 1000);

  //   const timeout = setTimeout(() => {
  //     const expiresAt = cookies.get("PendingLocationScheduleExpiresAt");

  //     toast.warning(
  //       <LocationEndToast
  //         onClick={handleLocationToastEndClick}
  //         autoHideDuration={expiresAt ? 6000 : ""}
  //       />,
  //       null,
  //       true,
  //       <WarningIcon />,
  //       { backgroundColor: "#fff8e1", color: "#6d4c41" },
  //     );
  //   }, initialSeconds * 1000);

  //   setToastTimer({ interval, timeout });
  // };

  sessionStorage.setItem(
    "googleMapData",
    JSON.stringify({
      ...googleMapData,
    }),
  );

  useEffect(() => {
    let homeLat = null;
    let homeLong = null;
    if (enrolleeUser?.clientId && jwtTokenData?.jwtToken) {
      clientProfiles(enrolleeUser?.clientId)
        .then((x) => {
          setUserData(x);
          sessionStorage.setItem("clientProfiles", JSON.stringify(x));
          if (x?.length > 0) {
            homeLat = x[0]?.homeLatitude;
            homeLong = x[0]?.homeLongitude;
          }
          sessionStorage.setItem(
            "enrolleeUser",
            JSON.stringify({
              ...enrolleeUser,
              homeLat,
              homeLong,
            }),
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  useEffect(() => {
    return () => {
      toastTimer?.interval && clearInterval(toastTimer.interval);
      toastTimer?.preEndTimeout && clearTimeout(toastTimer.preEndTimeout);
      toastTimer?.timeout && clearTimeout(toastTimer.timeout);
    };
  }, [toastTimer]);

  useEffect(() => {
    return () => {
      if (startToastIdRef.current) {
        toast.dismiss(startToastIdRef.current);
        startToastIdRef.current = null;
      }
      if (endToastIdRef.current) {
        toast.dismiss(endToastIdRef.current);
        endToastIdRef.current = null;
      }
      sessionStorage.removeItem("locationToastOverlay");
    };
  }, [toast]);

  const LocationStartToast = ({ seconds }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
        minWidth: 300,
      }}
    >
      <span style={{ fontWeight: 600 }}>
        {t("location.appointmentReserved")}
      </span>
      <span style={{ fontWeight: 700 }}>
        {moment.utc(seconds * 1000).format("m:ss")}
      </span>
    </div>
  );

  const LocationEndToast = ({ onClick }) => (
    <span onClick={onClick}>
      <span style={{ fontWeight: 600 }}>
        {t("location.noAppointmentReserved")}
      </span>
      <br />
      <span>
        <u style={{ cursor: "pointer" }}>{t("location.clickHere")} </u>{" "}
        {t("location.restartAppointment")}
      </span>
    </span>
  );

  useEffect(() => {
    const pending = cookies.get("PendingLocationSchedule");
    const expiresAt = cookies.get("PendingLocationScheduleExpiresAt");

    if (!pending || !expiresAt) return;
    if (hasAppointment) return;

    const remainingMs = Number(expiresAt) - Date.now();
    if (Number.isNaN(remainingMs) || remainingMs <= 0) return;

    const remainingSeconds = Math.ceil(remainingMs / 1000);

    startLocationToastFlow(remainingSeconds);
  }, []);

  useEffect(() => {
    const overlayFlag = sessionStorage.getItem("locationToastOverlay");
    if (overlayFlag === "1") {
      setShowToastOverlay(true);
      setDeviceChangeModalOpen(false);
      setPendingDeviceReschedule(null);
      const endToastId = toast.warning(
        <LocationEndToast
          onClick={() => handleLocationToastEndClick(endToastId)}
        />,
        null,
        true,
        <WarningIcon />,
        { backgroundColor: "#fff8e1", color: "#6d4c41" },
        locationToastSnackbarSx,
        true,
      );
      endToastIdRef.current = endToastId;
    }
  }, []);

  useEffect(() => {
    if (!showToastOverlay) return;

    window.history.pushState({ locationToastOverlay: true }, "");

    const handlePopState = () => {
      handleLocationToastEndClick(endToastIdRef.current);
      window.history.pushState({ locationToastOverlay: true }, "");
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [showToastOverlay]);

  const handleLocationToastEndClick = async (toastId) => {
    if (isHandlingToastEndRef.current) return;
    isHandlingToastEndRef.current = true;
    const resolvedToastId = toastId || endToastIdRef.current;
    if (resolvedToastId) {
      toast.dismiss(resolvedToastId);
    } else {
      toast.dismiss();
    }
    if (startToastIdRef.current) {
      toast.dismiss(startToastIdRef.current);
      startToastIdRef.current = null;
    }
    setPageLoading(true);
    setShowToastOverlay(false);
    sessionStorage.removeItem("locationToastOverlay");
    sessionStorage.removeItem("skipLocationScheduleInit");

    let appointmentCheckTimeout;
    const appointmentExists = await Promise.race([
      refreshAppointments(),
      new Promise((resolve) => {
        appointmentCheckTimeout = setTimeout(() => resolve(null), 10000);
      }),
    ]);
    clearTimeout(appointmentCheckTimeout);

    if (appointmentExists === null) {
      const retryToastId = toast.warning(
        <LocationEndToast
          onClick={() => handleLocationToastEndClick(retryToastId)}
        />,
        null,
        true,
        <WarningIcon />,
        { backgroundColor: "#fff8e1", color: "#6d4c41" },
        locationToastSnackbarSx,
        true,
      );
      endToastIdRef.current = retryToastId;
      setShowToastOverlay(true);
      sessionStorage.setItem("locationToastOverlay", "1");
      setPageLoading(false);
      isHandlingToastEndRef.current = false;
      return;
    }

    if (appointmentExists) {
      clearLocationToastFlow();
      setPageLoading(false);
      isHandlingToastEndRef.current = false;
      window.location.replace(`${process.env.CP_URL}/appointments`);
      return;
    }

    clearLocationToastFlow();
    const enrolleeUserRaw = sessionStorage.getItem("enrolleeUser");
    let existingEnrollee = {};
    let pendingViolationDraft = {};

    try {
      pendingViolationDraft =
        JSON.parse(sessionStorage.getItem(LOCATION_VIOLATION_DRAFT_KEY)) || {};
    } catch (error) {
      console.error("Failed to parse Location State Info draft", error);
    }

    if (enrolleeUserRaw) {
      try {
        existingEnrollee = JSON.parse(enrolleeUserRaw);
        const restartDeviceType = resolveDeviceTypeValue(
          pendingViolationDraft?.deviceType,
          existingEnrollee?.deviceType,
        );
        const restartClientTypeId = resolveClientTypeId(restartDeviceType);
        const restartIsPortable =
          normalizeDeviceTypeCandidate(restartDeviceType) === "Portable";
        sessionStorage.setItem(
          "enrolleeUser",
          JSON.stringify({
            ...existingEnrollee,
            ...(restartDeviceType && {
              deviceType: restartDeviceType,
              deviceSelectionConfirmed: true,
              deviceSelectionSource: "user",
              clientTypeId:
                restartClientTypeId || existingEnrollee?.clientTypeId,
              ClientTypeId:
                restartClientTypeId || existingEnrollee?.ClientTypeId,
              clientTypeID:
                restartClientTypeId || existingEnrollee?.clientTypeID,
              ClientTypeID:
                restartClientTypeId || existingEnrollee?.ClientTypeID,
            }),
            step: "Schedule",
            Step: "Schedule",
            story: "Location",
            Story: "Location",
            make: "",
            model: "",
            vehYear: 0,
            vehicleId: 0,
            vehicleID: 0,
            ...(restartIsPortable && {
              VehicleId: null,
              VehicleID: null,
              selectedVehicleId: null,
              selectedVehicleID: null,
              vehicleInfo: null,
            }),
          }),
        );
        if (restartDeviceType) {
          setDeviceLocationType(restartDeviceType);
        }
      } catch (error) {
        console.error("Failed to reset EnrolleeUser in sessionStorage", error);
      }
    }

    const restartDeviceType = resolveDeviceTypeValue(
      pendingViolationDraft?.deviceType,
      existingEnrollee?.deviceType,
    );
    sessionStorage.removeItem(LOCATION_VIOLATION_DRAFT_KEY);
    sessionStorage.removeItem("appointmentCreatedFlag");
    sessionStorage.removeItem("locationVehicleConfirmed");
    sessionStorage.removeItem("locationResumeStateInfoAfterVehicle");
    sessionStorage.removeItem("locationReturnToVehicleAfterContact");
    sessionStorage.removeItem("forceLocationZipAfterVehicle");
    setVehicleReadyForLocation(false);
    setResumeStateInfoAfterVehicle(false);
    setActiveStep(locationStepIndexMap.Schedule);
    setStepSchedule(STEPS.SCHEDULE_NOW);
    setFlagClickReset(true);
    setPageLoading(false);

    try {
      if (enrolleeUser?.enrolleeId) {
        const enrolleeUpdateResponse = await enrolleeUpdate({
          enrolleeId: enrolleeUser?.enrolleeId,
          clientId: enrolleeUser?.clientId,
          story: "Location",
          step: "Schedule",
          deviceType: restartDeviceType,
          contactPreference: pereferedContact || "Phone",
        });
        if (enrolleeUpdateResponse?.step) {
          const currentEnrollee =
            JSON.parse(sessionStorage.getItem("enrolleeUser")) ||
            existingEnrollee;
          sessionStorage.setItem(
            "enrolleeUser",
            JSON.stringify({
              ...currentEnrollee,
              step: enrolleeUpdateResponse.step,
              Step: enrolleeUpdateResponse.step,
              story: "Location",
              Story: "Location",
            }),
          );
        }
      }
    } catch (error) {
      console.log("enrolleeUpdate failed", error);
    } finally {
      setPageLoading(false);
      isHandlingToastEndRef.current = false;
    }
  };

  function clearLocationToastFlow() {
    toastTimer?.interval && clearInterval(toastTimer.interval);
    toastTimer?.preEndTimeout && clearTimeout(toastTimer.preEndTimeout);
    toastTimer?.timeout && clearTimeout(toastTimer.timeout);
    setToastTimer(null);

    if (startToastIdRef.current) {
      toast.dismiss(startToastIdRef.current);
      startToastIdRef.current = null;
    }
    if (endToastIdRef.current) {
      toast.dismiss(endToastIdRef.current);
      endToastIdRef.current = null;
    }

    setShowToastOverlay(false);
    sessionStorage.removeItem("locationToastOverlay");
    cookies.remove("PendingLocationSchedule", { path: "/" });
    cookies.remove("PendingAppointment", { path: "/" });
    cookies.remove("PendingLocationScheduleExpiresAt", { path: "/" });
  }

  const handleCancelDeviceReschedule = () => {
    setDeviceChangeModalOpen(false);
    setPendingDeviceReschedule(null);
    sessionStorage.removeItem(LOCATION_VIOLATION_DRAFT_KEY);
  };

  const handleConfirmDeviceReschedule = async () => {
    const nextDeviceType = pendingDeviceReschedule?.nextDeviceType || null;
    const isPortableDevice =
      normalizeDeviceTypeCandidate(nextDeviceType) === "Portable";
    const existingEnrollee =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
    const nextClientTypeId = resolveClientTypeId(nextDeviceType);
    let pendingViolationDraft = {};

    try {
      pendingViolationDraft =
        JSON.parse(sessionStorage.getItem(LOCATION_VIOLATION_DRAFT_KEY)) || {};
    } catch (error) {
      console.error("Failed to parse Location State Info draft", error);
    }

    const nextStep = isPortableDevice ? "Schedule" : "Vehicle";
    const clearedPortableVehicle = isPortableDevice
      ? {
          vehicleId: null,
          vehicleID: null,
          VehicleId: null,
          VehicleID: null,
          selectedVehicleId: null,
          selectedVehicleID: null,
          vehicleInfo: null,
          vehYear: 0,
          make: "",
          model: "",
        }
      : {};

    try {
      setSubmitting(true);
      await clientUpdate({
        ...pendingViolationDraft,
        clientId:
          pendingViolationDraft?.clientId || existingEnrollee?.clientId,
        ClientId:
          pendingViolationDraft?.ClientId || existingEnrollee?.ClientId,
        enrolleeId:
          pendingViolationDraft?.enrolleeId || existingEnrollee?.enrolleeId,
        EnrolleeId:
          pendingViolationDraft?.EnrolleeId || existingEnrollee?.EnrolleeId,
        deviceType: nextDeviceType,
        clientTypeId: nextClientTypeId,
        ClientTypeId: nextClientTypeId,
        contactPreference: pereferedContact || "Phone",
        step: nextStep,
        Step: nextStep,
        story: "Location",
      });
    } catch (error) {
      console.error("Failed to update client device", error);
      toast.error(t("toasts.updateFailed"));
      return;
    } finally {
      setSubmitting(false);
    }

    clearLocationToastFlow();
    sessionStorage.removeItem("appointmentData");
    sessionStorage.removeItem("appointmentCreatedFlag");
    sessionStorage.removeItem("locationFlag");
    sessionStorage.removeItem(LOCATION_VIOLATION_DRAFT_KEY);

    setAppointmentData(null);
    setHasAppointment(false);
    hasAppointmentRef.current = false;

    if (nextDeviceType) {
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify({
          ...existingEnrollee,
          ...pendingViolationDraft,
          deviceType: nextDeviceType,
          DeviceType: nextDeviceType,
          deviceSelectionConfirmed: true,
          deviceSelectionSource: "user",
          clientTypeId: nextClientTypeId || existingEnrollee?.clientTypeId,
          ClientTypeId: nextClientTypeId || existingEnrollee?.ClientTypeId,
          clientTypeID: nextClientTypeId || existingEnrollee?.clientTypeID,
          ClientTypeID: nextClientTypeId || existingEnrollee?.ClientTypeID,
          ...clearedPortableVehicle,
          step: nextStep,
          Step: nextStep,
          story: "Location",
          Story: "Location",
        }),
      );
      syncLocationClientProfiles(pendingViolationDraft, nextClientTypeId);
      setDeviceLocationType(nextDeviceType);
      forceSessionSync((x) => x + 1);
    }

    setDeviceChangeModalOpen(false);
    setPendingDeviceReschedule(null);
    dismissLocationWelcome();
    sessionStorage.removeItem("locationVehicleConfirmed");
    setVehicleReadyForLocation(false);
    setStepSchedule(STEPS.SCHEDULE_NOW);
    setActiveStep(
      isPortableDevice
        ? locationStepIndexMap.Schedule
        : locationStepIndexMap.Vehicle,
    );
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 15,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "#eeeeee",
      ...theme.applyStyles("dark", {
        backgroundColor: "#eeeeee",
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 40,
      backgroundColor: `#76BC21`,
      ...theme.applyStyles("dark", {
        backgroundColor: `#76BC21`,
      }),
    },
  }));

  const stepsInfo = [
    // {
    //   name: "Device",
    //   step: 0,
    //   progressBarValue: null,
    //   icon: null,
    //   title: "",
    //   description: "",
    // },
    {
      name: "Schedule",
      step: 0,
      progressBarValue: null,
      icon: null,
      title: "",
      description: "",
    },
    {
      name: "Contact",
      step: 1,
      progressBarValue: 25,
      icon: null,
      title: !shouldShowLocationWelcome && t("steps.aboutYou"),
      description: !shouldShowLocationWelcome && t("steps.aboutMessage"),
    },
    // {
    //   name: "Violation",
    //   step: 3,
    //   progressBarValue: null,
    //   icon: null,
    //   title: "",
    //   description: "",
    // },
    {
      name: "Violation",
      step: 3,
      progressBarValue: 45,
      icon: null,
      title: t("steps.stateInfo"),
      description: t("steps.stateMessage"),
    },
    {
      name: "Vehicle",
      step: 2,
      progressBarValue: isPam ? 85 : 70,
      icon: null,
      title: t("steps.vehicleInfo"),
      description: null,
    },
    {
      name: "StateId",
      step: 3,
      progressBarValue: 85,
      icon: null,
      title: t("steps.yourStateId"),
      description: t("steps.yourStateDescription"),
    },
    {
      name: "Address",
      step: 6,
      progressBarValue: 95,
      icon: null,
      title: t("steps.yourAddress"),
      description: t("steps.yourAddressDescriptionLocation"),
    },
    {
      name: "MyAccount",
      step: 7,
      progressBarValue: 100,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      // icon: null,
      title: t("location.booked"),
      description: t("location.confirmationSent"),
    },
  ];

  const StepsHeader = ({ title, description }) => {
    return (
      <>
        {title || description ? (
          <Grid
            sx={{
              mt: 2,
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: "#4b9CD3",
                fontWeight: 600,
              }}
            >
              {title}
            </Typography>
            <Typography sx={{ textAlign: "center", mt: 1 }}>
              {description}
            </Typography>
          </Grid>
        ) : null}
      </>
    );
  };

  StepsHeader.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
  };

  const contactInfoForm = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      firstName: enrolleeUser?.firstName || enrolleeUser?.FirstName || null,
      lastName: enrolleeUser?.lastName || enrolleeUser?.LastName || null,
      cellPhone: enrolleeUser?.cellPhone || enrolleeUser?.CellPhone || null,
      email: enrolleeUser?.email || enrolleeUser?.Email,
      preferedContact: null,
      call_me_out: null,
      zip: enrolleeUser?.zip || null,
    },
  });

  const goToBackStep = () => {
    if (activeStep === locationStepIndexMap.Vehicle) {
      const currentEnrollee =
        JSON.parse(sessionStorage.getItem("enrolleeUser")) ||
        enrolleeUser ||
        {};
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify({
          ...currentEnrollee,
          step: "Violation",
          Step: "Violation",
          story: "Location",
          Story: "Location",
        }),
      );
      sessionStorage.removeItem("locationReturnToVehicleAfterContact");
      sessionStorage.removeItem("locationResumeStateInfoAfterVehicle");
      setResumeStateInfoAfterVehicle(false);
      setActiveStep(locationStepIndexMap.Violation);
    } else if (activeStep === locationStepIndexMap.Violation) {
      sessionStorage.setItem("locationResumeStateInfoAfterVehicle", "true");
      setResumeStateInfoAfterVehicle(true);
      setActiveStep(locationStepIndexMap.Contact);
    } else if (
      activeStep === locationStepIndexMap.StateId &&
      (hasActiveLocationReservation ||
        isPamForLocation ||
        vehicleReadyForLocation)
    ) {
      setActiveStep(locationStepIndexMap.Violation);
    } else if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const goToNextStep = () => {
    if (
      activeStep === locationStepIndexMap.Violation &&
      (hasActiveLocationReservation || isPamForLocation)
    ) {
      setActiveStep(locationStepIndexMap.StateId);
      return;
    }

    setActiveStep((prev) => prev + 1);
  };

  useEffect(() => {
    if (enrolleeUser) {
      const derivedDeviceType = resolveDeviceTypeValue(
        deviceLocationType,
        enrolleeUser?.deviceType,
        enrolleeUser?.clientTypeId,
        enrolleeUser?.ClientTypeId,
        DeviceType,
      );

      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify({
          ...enrolleeUser,
          deviceType: derivedDeviceType || null,
        }),
      );
    }
  }, [deviceLocationType, enrolleeUser]);

  useEffect(() => {
    if (isEnrolleeLoadNeeded === true && jwtTokenData?.jwtToken) {
      const reloadEnrollee = async () => {
        if (
          enrolleeUser?.clientId !== undefined &&
          enrolleeUser?.userId !== undefined
        ) {
          try {
            const enrolleeData = await loadEnrollee(
              enrolleeUser?.clientId,
              enrolleeUser?.userId,
            );
            if (enrolleeData) {
              const syncedStep =
                enrolleeData?.step ||
                enrolleeData?.Step ||
                enrolleeUser?.step ||
                enrolleeUser?.Step;
              const syncedStory =
                enrolleeData?.story ||
                enrolleeData?.Story ||
                enrolleeUser?.story ||
                enrolleeUser?.Story;

              sessionStorage.setItem(
                "enrolleeUser",
                JSON.stringify({
                  ...enrolleeUser,
                  ...enrolleeData,
                  ...(syncedStep && { step: syncedStep, Step: syncedStep }),
                  ...(syncedStory && {
                    story: syncedStory,
                    Story: syncedStory,
                  }),
                  deviceType: resolveDeviceTypeValue(
                    enrolleeData?.clientTypeId,
                    enrolleeData?.ClientTypeId,
                    enrolleeData?.deviceType,
                    enrolleeUser?.clientTypeId,
                    enrolleeUser?.ClientTypeId,
                    enrolleeUser?.deviceType,
                    deviceLocationType,
                    DeviceType,
                  ),
                }),
              );

              if (enrolleeData?.contactPreference) {
                setPreferedContact(enrolleeData?.contactPreference);
              }
            }
          } catch (error) {
            console.error(error);
          } finally {
            setIsEnrolleeLoadNeeded(false);
          }
        }
      };

      reloadEnrollee();
    }
  }, [isEnrolleeLoadNeeded]);

  const handleReferalSubmit = () => {
    dismissLocationWelcome();

    const storedEnrolleeUser =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
    const { isReferralModalSubmit, ...cleanEnrolleeUser } = storedEnrolleeUser;

    if (isReferralModalSubmit) {
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify(
          utilities.normalizeEnrolleeSessionData(cleanEnrolleeUser),
        ),
      );
    }

    const PendingAppointments = getPendingAppointmentData();
    const hasPendingLocationReservation =
      hasReservedPendingLocationAppointment(PendingAppointments);
    const requiresProgramInfo = !hasUsableEnrollmentCode(
      cookies.get("lsEnrollmentCode"),
    );
    const shouldResumeStateInfoAfterContact =
      resumeStateInfoAfterVehicle ||
      sessionStorage.getItem("locationResumeStateInfoAfterVehicle") === "true";
    const shouldReturnToVehicleAfterContact =
      sessionStorage.getItem("locationReturnToVehicleAfterContact") === "true";

    if (
      !hasPendingLocationReservation &&
      !shouldResumeStateInfoAfterContact
    ) {
      sessionStorage.removeItem("locationResumeStateInfoAfterVehicle");
      setResumeStateInfoAfterVehicle(false);
    }

    if (shouldResumeStateInfoAfterContact) {
      hasHandledCookieLocationStepRef.current = true;
      sessionStorage.removeItem("locationReturnToVehicleAfterContact");
      sessionStorage.removeItem("locationResumeStateInfoAfterVehicle");
      setResumeStateInfoAfterVehicle(false);
      setActiveStep(locationStepIndexMap.Violation);
    } else if (
      hasPendingLocationReservation &&
      hasResolvedLocationProgramInfo
    ) {
      sessionStorage.removeItem("locationReturnToVehicleAfterContact");
      sessionStorage.removeItem("locationResumeStateInfoAfterVehicle");
      setResumeStateInfoAfterVehicle(false);
      setActiveStep(locationStepIndexMap.StateId);
    } else if (hasPendingLocationReservation) {
      sessionStorage.removeItem("locationReturnToVehicleAfterContact");
      sessionStorage.removeItem("locationResumeStateInfoAfterVehicle");
      setResumeStateInfoAfterVehicle(false);
      setActiveStep(locationStepIndexMap.Violation);
    } else if (requiresProgramInfo) {
      sessionStorage.removeItem("locationReturnToVehicleAfterContact");
      sessionStorage.removeItem("locationResumeStateInfoAfterVehicle");
      setResumeStateInfoAfterVehicle(false);
      setActiveStep(locationStepIndexMap.Violation);
    } else if (shouldReturnToVehicleAfterContact) {
      sessionStorage.removeItem("locationReturnToVehicleAfterContact");
      sessionStorage.removeItem("locationResumeStateInfoAfterVehicle");
      setResumeStateInfoAfterVehicle(false);
      setActiveStep(locationStepIndexMap.Vehicle);
    } else if (!isPamForLocation) {
      setActiveStep(locationStepIndexMap.Vehicle);
    } else {
      const currentEnrollee =
        JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify({
          ...currentEnrollee,
          step: "Schedule",
          Step: "Schedule",
          story: "Location",
          Story: "Location",
        }),
      );
      setActiveStep(0);
      if (!locationIdFromCookie) {
        setStepSchedule(STEPS?.LOCATION_ZIP);
        setFlagDevice(true);
      }
    }

    setReferralModal(false);
    return;
  };

  const confirmLocationVehicle = () => {
    sessionStorage.setItem("locationVehicleConfirmed", "true");
    setVehicleReadyForLocation(true);
  };

  const handleUpdate = async (currentStep, updateData) => {
    if (updateData) {
      setSubmitting(true);
    }

    // enrolleeDataArray.current = {
    //   ...enrolleeDataArray.current,
    //   ...updateData,
    // };
    const currentEnrolleeSession =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
    const enrolleeID =
      currentEnrolleeSession?.enrolleeId ||
      currentEnrolleeSession?.EnrolleeId ||
      currentEnrolleeSession?.enrolleeID ||
      enrolleeUser?.enrolleeId ||
      enrolleeUser?.EnrolleeId ||
      enrolleeUser?.enrolleeID;
    const clientId =
      currentEnrolleeSession?.clientId ||
      currentEnrolleeSession?.ClientId ||
      currentEnrolleeSession?.clientID ||
      currentEnrolleeSession?.ClientID ||
      enrolleeUser?.clientId ||
      enrolleeUser?.ClientId ||
      enrolleeUser?.clientID ||
      enrolleeUser?.ClientID;
    const jwtToken = jwtTokenData?.jwtToken;
    const persistedStep =
      currentStep === "Referral"
        ? "Contact"
        : currentStep === "Address" &&
            storyName?.toLowerCase() === "location"
          ? "MyAccount"
          : currentStep;

    try {
      if (enrolleeID && jwtToken) {
        const enrolleData = {
          ...updateData,
          enrolleeId: enrolleeID,
          story: "Location",
          step: persistedStep,
          contactPreference: pereferedContact || "Phone",
          deviceType:
            storyName?.toLowerCase() === "speed"
              ? "Speed"
              : resolveDeviceTypeValue(
                  updateData?.deviceType,
                  deviceLocationType,
                  enrolleeUser?.deviceType,
                ),
          utM_source: UTM_source || null,
          utM_medium: UTM_medium || null,
          utM_campaign: UTM_campaign || null,
          gA_clientid: GA_clientid || null,
          gclID: gclid || null,
          userAgent: UserAgent || null,
          ipAddress: IPAddress || null,
          wbraid: wbraid || null,
          gbraid: gbraid || null,
          fbclid: fbclid || null,
          fbp: fbp || null,
          ttclid: ttclid || null,
          rdt_cid: rdt_cid || null,
          page: Page || null,
          referURL: URL?.slice(0, 500) || null,
        };
        await enrolleeUpdate(enrolleData);
      }
      if (currentStep === "Referral") {
        handleReferalSubmit();
        return;
      }
      switch (currentStep) {
        case "Device":
          break;
        case "Contact":
          try {
            const currentLocationSession =
              JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
            const selectedLocationDeviceType = resolveDeviceTypeValue(
              deviceLocationType,
              currentLocationSession?.deviceType,
              enrolleeUser?.deviceType,
            );
            updateData = {
              ...updateData,
              ...(selectedLocationDeviceType && {
                deviceType: selectedLocationDeviceType,
              }),
            };

            if (!enrolleeID || !jwtToken) {
              // updateData = {
              //   ...updateData,
              //   ...{
              //     deviceType:
              //       storyName?.toLowerCase() === "speed" ||
              //       storyName?.toLowerCase() === "isa volunteer"
              //         ? "Speed"
              //         : utilities?.deviceInfo(
              //             enrolleeUser?.clientTypeId || deviceLocationType,
              //           )?.deviceType,
              //   },
              // };
              await registerEnrollee(updateData).then(async (enrolleeRes) => {
                cookies.set(
                  "lifesaferEnrollment",
                  JSON.stringify(enrolleeRes),
                  {
                    path: "/",
                    sameSite: "strict",
                  },
                );
                let enrolleeData = {
                  ...updateData,
                  enrolleeId: enrolleeRes?.enrolleeId,
                  clientId: enrolleeRes?.clientId,
                  story: "Location",
                  step: persistedStep,
                  utM_source: UTM_source || null,
                  utM_medium: UTM_medium || null,
                  utM_campaign: UTM_campaign || null,
                  gA_clientid: GA_clientid || null,
                  gclID: gclid || null,
                  userAgent: UserAgent || null,
                  ipAddress: IPAddress || null,
                  wbraid: wbraid || null,
                  gbraid: gbraid || null,
                  fbclid: fbclid || null,
                  fbp: fbp || null,
                  ttclid: ttclid || null,
                  rdt_cid: rdt_cid || null,
                  page: Page || null,
                  referURL: URL?.slice(0, 500) || null,
                };
                if (!enrolleeRes?.jwtToken) {
                  const currentEnrollee =
                    JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
                  sessionStorage.setItem(
                    "enrolleeUser",
                    JSON.stringify(
                      utilities.normalizeEnrolleeSessionData({
                        ...currentEnrollee,
                        ...enrolleeRes,
                        ...(selectedLocationDeviceType && {
                          deviceType: selectedLocationDeviceType,
                        }),
                      }),
                    ),
                  );

                  if (["TEXT", "EMAIL"].includes(enrolleeRes?.resetSent)) {
                    shouldSkipNextStep = true;
                    return navigate("/verify", {
                      state: {
                        enrollee: enrolleeRes,
                        lifeSaferUser: updateData,
                      },
                    });
                  }

                  if (enrolleeRes?.resetSent === "CALL") {
                    shouldSkipNextStep = true;
                    return navigate("/contact-page");
                  }
                }

                await enrolleeUpdate(enrolleeData);
                let clientSaveUpdateData = {
                  ...updateData,
                  UserId: enrolleeRes?.userId,
                  EnrolleeId: enrolleeRes?.enrolleeId,
                };
                if (hasUsableEnrollmentCode(enrollmentCodeData)) {
                  clientSaveResponse = await saveEnrollee(clientSaveUpdateData);
                }

                const savedClientId =
                  clientSaveResponse?.clientId || clientSaveResponse?.ClientId;
                const savedUserId =
                  clientSaveResponse?.userId ||
                  clientSaveResponse?.UserId ||
                  enrolleeRes?.userId ||
                  enrolleeRes?.UserId;
                const savedEnrolleeId =
                  clientSaveResponse?.enrolleeId ||
                  clientSaveResponse?.EnrolleeId ||
                  enrolleeRes?.enrolleeId ||
                  enrolleeRes?.EnrolleeId;

                let clientUpdateData = {
                  ...updateData,
                  UserId: savedUserId,
                  EnrolleeId: savedEnrolleeId,
                  ClientId: savedClientId,
                  step: persistedStep,
                  story: "Location",
                };
                if (clientSaveResponse) {
                  await clientUpdate(clientUpdateData);
                }

                let enrolleeSessionUpdateData = {
                  userId: savedUserId,
                  enrolleeId: savedEnrolleeId,
                  clientId: savedClientId,
                  step: persistedStep,
                  story: "Location",
                };

                enrolleeSessionUpdateData = {
                  ...enrolleeSessionUpdateData,
                  ...updateData,
                };
                sessionStorage.setItem(
                  "enrolleeUser",
                  JSON.stringify(
                    utilities.normalizeEnrolleeSessionData({
                      ...currentLocationSession,
                      ...enrolleeSessionUpdateData,
                      step: persistedStep,
                      Step: persistedStep,
                      story: "Location",
                      Story: "Location",
                    }),
                  ),
                );
              });
            } else {
              let clientUpdateData = {
                ...updateData,
                UserId: enrolleeUser?.userId,
                EnrolleeId: enrolleeUser?.enrolleeId,
                ClientId: enrolleeUser?.clientId,
                step: persistedStep,
                story: "Location",
              };

              updateData = {
                ...updateData,
                ...{ story: "Location" },
              };
              const sessionUpdateData = { ...updateData };
              delete sessionUpdateData.isReferralModalSubmit;
              const currentEnrollee =
                JSON.parse(sessionStorage.getItem("enrolleeUser")) ||
                enrolleeUser ||
                {};

              sessionStorage.setItem(
                "enrolleeUser",
                JSON.stringify(
                  utilities.normalizeEnrolleeSessionData({
                    ...currentEnrollee,
                    ...sessionUpdateData,
                    step: persistedStep,
                    Step: persistedStep,
                    story: "Location",
                    Story: "Location",
                  }),
                ),
              );

              if (clientId) {
                await clientUpdate({
                  ...clientUpdateData,
                  ClientId: clientId,
                });
              } else if (hasUsableEnrollmentCode(enrollmentCodeData)) {
                clientSaveResponse = await saveEnrollee(clientUpdateData);
                if (clientSaveResponse) {
                  const savedClientId =
                    clientSaveResponse?.clientId ||
                    clientSaveResponse?.ClientId;
                  const savedUserId =
                    clientSaveResponse?.userId || clientSaveResponse?.UserId;
                  const savedEnrolleeId =
                    clientSaveResponse?.enrolleeId ||
                    clientSaveResponse?.EnrolleeId;
                  let clientUpdateData = {
                    ...updateData,
                    UserId: savedUserId,
                    EnrolleeId: savedEnrolleeId,
                    ClientId: savedClientId,
                    step: persistedStep,
                    story: "Location",
                  };
                  await clientUpdate(clientUpdateData);

                  let dataClient = {
                    userId: savedUserId,
                    enrolleeId: savedEnrolleeId,
                    clientId: savedClientId,
                  };

                  sessionStorage.setItem(
                    "enrolleeUser",
                    JSON.stringify(
                      utilities.normalizeEnrolleeSessionData({
                        ...currentEnrollee,
                        ...dataClient,
                        step: persistedStep,
                        Step: persistedStep,
                        story: "Location",
                        Story: "Location",
                      }),
                    ),
                  );
                }
              }
            }
            if (updateData?.isReferralModalSubmit) {
              handleReferalSubmit();
              return;
            }
            setReferralModal(updateData?.isReferralModalSubmit ? false : true);
          } catch (error) {
            let errorMessage = JSON.parse(error.message);
            if (errorMessage?.errors?.EnrollmentCodeId[0]) {
              toast.error(errorMessage?.errors?.EnrollmentCodeId[0]);
            } else {
              let errMess = error.message;
              errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
              toast.error(errMess);
            }
            return;
          }
          break;
        case "Schedule":
          if (!jwtToken) {
            setActiveStep(1);
            return;
          }
          cookies.set("PendingAppointment", JSON.stringify(updateData), {
            path: "/",
          });
          cookies.set("PendingLocationSchedule", true, { path: "/" });
          cookies.set("PendingLocationScheduleExpiresAt", Date.now() + 600000, {
            path: "/",
          });

          startLocationToastFlow(600);

          try {
            const nextStep = hasResolvedLocationProgramInfo
              ? "StateId"
              : "Violation";
            updateData = {
              ...updateData,
              ...{
                deviceType:
                  storyName?.toLowerCase() === "speed" ||
                  storyName?.toLowerCase() === "isa volunteer"
                    ? "Speed"
                    : resolveDeviceTypeValue(
                        updateData?.deviceType,
                        deviceLocationType,
                        enrolleeUser?.deviceType,
                      ),
              },
            };

            updateData = {
              ...updateData,
              contactPreference: pereferedContact || "Phone",
              step: nextStep,
              story: "Location",
            };
            await enrolleeUpdate({
              ...updateData,
              enrolleeId: enrolleeID,
              clientId: clientId,
              step: nextStep,
            });
          } catch (error) {
            console.error(error);
          }

          break;

        // updateData = {
        //   ...updateData,
        //   contactPreference: pereferedContact || "Phone",
        //   story: "Location",
        // };
        // break;
        case "Violation":
          try {
            const pendingAppointment = getPendingAppointmentData();
            const selectedDeviceType = resolveDeviceTypeValue(
              updateData?.deviceType,
            );
            const pendingAppointmentDeviceType = resolveDeviceTypeValue(
              pendingAppointment?.deviceType,
              resolveDeviceTypeFromServiceId(pendingAppointment?.serviceID),
            );

            if (
              pendingAppointment &&
              selectedDeviceType &&
              pendingAppointmentDeviceType &&
              selectedDeviceType !== pendingAppointmentDeviceType
            ) {
              sessionStorage.setItem(
                LOCATION_VIOLATION_DRAFT_KEY,
                JSON.stringify({
                  ...updateData,
                  deviceType: selectedDeviceType,
                }),
              );
              setPendingDeviceReschedule({
                nextDeviceType: selectedDeviceType,
              });
              setDeviceChangeModalOpen(true);
              return;
            }

            if (!clientId) {
              if (!hasUsableEnrollmentCode(enrollmentCodeData)) {
                let contactInfoFormValue = contactInfoForm.watch();
                let newContactInfoData = {
                  step: "Violation",
                  firstName: contactInfoFormValue.firstName,
                  lastName: contactInfoFormValue.lastName,
                  homePhone: contactInfoFormValue.cellPhone,
                  email: contactInfoFormValue.email,
                  contactPreference: pereferedContact || "Phone",
                  BrandIdentifier: brand,
                  CellPhone: contactInfoFormValue.cellPhone,
                  // deviceType: deviceType || "IID",
                  EnrolleeId: enrolleeUser?.enrolleeId,
                  story: "Location",
                };

                updateData = {
                  ...updateData,
                  ...newContactInfoData,
                };
              }

              const enrolleeResponse = await saveEnrollee(updateData);
              const savedClientId =
                enrolleeResponse?.clientId || enrolleeResponse?.ClientId;
              const savedUserId =
                enrolleeResponse?.userId || enrolleeResponse?.UserId;
              const savedEnrolleeId =
                enrolleeResponse?.enrolleeId ||
                enrolleeResponse?.EnrolleeId;
              const newData = {
                ...updateData,
                clientId: savedClientId,
                userId: savedUserId,
                enrolleeId: savedEnrolleeId,
                contactPreference: pereferedContact || "Phone",
                story: "Location",
              };

              await clientUpdate(newData);

              const latestEnrolleeSession =
                JSON.parse(sessionStorage.getItem("enrolleeUser")) ||
                currentEnrolleeSession;
              sessionStorage.setItem(
                "enrolleeUser",
                JSON.stringify({
                  ...latestEnrolleeSession,
                  userId: savedUserId,
                  enrolleeId: savedEnrolleeId,
                  clientId: savedClientId,
                  enrollmentCode: updateData?.enrollmentCode,
                  enrollmentCodeId: updateData?.enrollmentCodeId,
                  step: "Violation",
                  Step: "Violation",
                  story: "Location",
                  Story: "Location",
                }),
              );

              if (!hasUsableEnrollmentCode(enrollmentCodeData)) {
                const enrolleeCodeData = {
                  enrollmentCode: updateData?.enrollmentCode,
                  enrollmentCodeId: updateData?.enrollmentCodeId,
                };

                cookies.set(
                  "lsEnrollmentCode",
                  { ...enrollmentCodeData, ...enrolleeCodeData },
                  {
                    path: "/",
                    sameSite: "strict",
                  },
                );
              }
            } else {
              updateData = {
                ...updateData,
                clientId,
                ClientId: clientId,
                enrolleeId: enrolleeID,
                EnrolleeId: enrolleeID,
                contactPreference: pereferedContact || "Phone",
                story: "Location",
              };

              let enrolleeCodeData = {
                enrollmentCode: updateData?.enrollmentCode,
                enrollmentCodeId: updateData?.enrollmentCodeId,
              };
              cookies.set(
                "lsEnrollmentCode",
                { ...enrollmentCodeData, ...enrolleeCodeData },
                {
                  path: "/",
                  sameSite: "strict",
                },
              );
              await clientUpdate(updateData);
            }

            if (selectedDeviceType) {
              const selectedClientTypeId =
                resolveClientTypeId(selectedDeviceType);
              const currentEnrollee =
                JSON.parse(sessionStorage.getItem("enrolleeUser")) ||
                enrolleeUser ||
                {};

              sessionStorage.setItem(
                "enrolleeUser",
                JSON.stringify({
                  ...currentEnrollee,
                  deviceType: selectedDeviceType,
                  DeviceType: selectedDeviceType,
                  clientTypeId: selectedClientTypeId,
                  ClientTypeId: selectedClientTypeId,
                  clientTypeID: selectedClientTypeId,
                  ClientTypeID: selectedClientTypeId,
                  deviceSelectionConfirmed: true,
                  deviceSelectionSource: "user",
                  ConvictionStateID: updateData?.ConvictionStateID,
                  ConvictionCountyID: updateData?.ConvictionCountyID,
                  programType: updateData?.programType,
                  contractEnd: updateData?.contractEnd,
                  protPlan: updateData?.protPlan,
                  step: "Violation",
                  Step: "Violation",
                  story: "Location",
                  Story: "Location",
                }),
              );
              setDeviceLocationType(selectedDeviceType);
              setIsPam(selectedClientTypeId === 5);
              if (selectedClientTypeId !== 5) {
                sessionStorage.removeItem("locationVehicleConfirmed");
                setVehicleReadyForLocation(false);
              }
              forceSessionSync((value) => value + 1);
            }

            syncLocationClientProfiles(
              updateData,
              resolveClientTypeId(selectedDeviceType),
            );

            sessionStorage.removeItem(LOCATION_VIOLATION_DRAFT_KEY);
            sessionStorage.setItem(
              LOCATION_PROGRAM_INFO_COMPLETED_KEY,
              "true",
            );
            setHasCompletedLocationProgramInfo(true);
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }

          break;
        case "Vehicle":
          try {
            if (!updateData) {
              confirmLocationVehicle();
              break;
            }
            const result = await saveNewVehicle(updateData);
            if (result) {
              const vehicleData = await loadVehicle(
                enrolleeUser?.clientId,
                enrolleeUser?.userId,
              );

              const matchedVehicle = vehicleData?.find(
                (x) => x.vehicleId === result,
              );

              if (matchedVehicle) {
                const vehicleWithoutUserId = { ...matchedVehicle };
                delete vehicleWithoutUserId.userId;
                sessionStorage.setItem(
                  "enrolleeUser",
                  JSON.stringify({
                    ...enrolleeUser,
                    ...updateData,
                    ...vehicleWithoutUserId,
                    step: "Vehicle",
                    Step: "Vehicle",
                    story: "Location",
                    Story: "Location",
                  }),
                );

                const PendingAppointmentDatas =
                  cookies.get("PendingAppointment");

                cookies.set(
                  "PendingAppointment",
                  JSON.stringify({
                    ...PendingAppointmentDatas,
                    ...vehicleWithoutUserId,
                  }),
                  {
                    path: "/",
                  },
                );
              }
            }
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return false;
          }
          confirmLocationVehicle();
          break;
        case "StateId":
          try {
            let newData = {
              ...updateData,
              clientId: enrolleeUser?.ClientId || enrolleeUser?.clientId,
              enrolleeId: enrolleeUser?.enrolleeId || enrolleeUser?.enrolleeID,
              userId: enrolleeUser?.UserId || enrolleeUser?.userId,
              contactPreference: pereferedContact || "Phone",
              step: currentStep,
              story: "Location",
              deviceType: resolveDeviceTypeValue(
                updateData?.deviceType,
                deviceLocationType,
                enrolleeUser?.deviceType,
              ),
            };

            let enrolleeCodeData = {
              enrollmentCode: updateData?.enrollmentCode,
              enrollmentCodeId: updateData?.enrollmentCodeId,
            };
            cookies.set(
              "lsEnrollmentCode",
              { ...enrollmentCodeData, ...enrolleeCodeData },
              {
                path: "/",
                sameSite: "strict",
              },
            );
            await clientUpdate(newData);
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }
          break;
        case "Address":
          try {
            let isVehicleClient = {};

            if (
              enrolleeUser?.deviceType !== "PAM" ||
              enrolleeUser?.clientTypeId === 5
            ) {
              isVehicleClient = {
                vehYear: null,
                make: null,
                model: null,
              };
            }

            // let vehicleData = {
            //   vehicleID: isVehicleClient ? enrolleeUser?.vehicleId : 0,

            //   vehYear: isVehicleClient ? enrolleeUser?.vehYear : 0,
            //   make: isVehicleClient ? enrolleeUser?.make : "",
            //   model: isVehicleClient ? enrolleeUser?.model : "",
            //   serviceID:
            //     enrolleeUser?.clientTypeId === 1
            //       ? 1
            //       : enrolleeUser?.clientTypeId === 5
            //         ? 290
            //         : enrolleeUser?.clientTypeId === 6
            //           ? 396
            //           : 0,
            //   deviceType:
            //     enrolleeUser?.clientTypeId === 1
            //       ? "IID"
            //       : enrolleeUser?.clientTypeId === 5
            //         ? "PAM"
            //         : enrolleeUser?.clientTypeId === 6
            //           ? "ISA"
            //           : "IID",
            // };
            const PendingAppointmentData = cookies.get("PendingAppointment");
            let newAppointmentData = {
              ...PendingAppointmentData,
              vehicleID: isVehicleClient ? enrolleeUser?.vehicleId : 0,

              vehYear: isVehicleClient ? enrolleeUser?.vehYear : 0,
              make: isVehicleClient ? enrolleeUser?.make : "",
              model: isVehicleClient ? enrolleeUser?.model : "",
              serviceID:
                enrolleeUser?.clientTypeId === 1
                  ? 1
                  : enrolleeUser?.clientTypeId === 5
                    ? 290
                    : enrolleeUser?.clientTypeId === 6
                      ? 396
                      : 0,
              deviceType:
                enrolleeUser?.deviceType === "Interlock" ||
                enrolleeUser?.clientTypeId === 1
                  ? "IID"
                  : enrolleeUser?.deviceType === "Portable" ||
                      enrolleeUser?.clientTypeId === 5
                    ? "PAM"
                    : enrolleeUser?.deviceType === "Speed" ||
                        enrolleeUser?.clientTypeId === 6
                      ? "ISA"
                      : "IID",
            };
            const newAppointment = await createAppointment(newAppointmentData);

            if (newAppointment.appointmentID > 0) {
              clearLocationToastFlow();
              const enrolleeDeviceType =
                resolveDeviceTypeValue(
                  updateData?.deviceType,
                  deviceLocationType,
                  enrolleeUser?.deviceType,
                ) || "Interlock";

              let enrolleeData = {
                ...updateData,
                enrolleeId: enrolleeID,
                clientId: clientId,
                step: "MyAccount",
                complete: true,
                deviceType: enrolleeDeviceType,
                UTM_source: UTM_source || null,
                UTM_medium: UTM_medium || null,
                UTM_campaign: UTM_campaign || null,
                GA_clientid: GA_clientid || null,
                page: Page || null,
                referURL: URL?.slice(0, 500) || null,
              };

              await enrolleeUpdate(enrolleeData);
              toast.success(t("outro.apptSaveSuccess"));
            }
          } catch (error) {
            console.error("Error getting enrollment:", error);
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }
          updateData = {
            ...updateData,
            contactPreference: pereferedContact || "Phone",
            story: "Location",
            step: "MyAccount",
          };
          try {
            await clientUpdate(updateData);
            sessionStorage.setItem(
              "enrolleeUser",
              JSON.stringify({
                ...enrolleeUser,
                ...updateData,
                step: "MyAccount",
                Step: "MyAccount",
                story: "Location",
                Story: "Location",
              }),
            );
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }
          break;
        case "MyAccount":
          setSubmitting(true);

          try {
            if (!enrolleeUser) {
              toast.error(t("location.sessionExpired"));
              return;
            }

            await updateProfile(enrolleeUser.clientID, {
              ...enrolleeUser,
              userID: enrolleeUser?.userId,
              jurisdictionID: user?.jurisdictionID,
            });

            await resetProfilePassword(
              enrolleeUser?.userId,
              updateData?.password,
            );

            const emailObj = {
              emailAddress: enrolleeUser.email,
              brandIdentifier: brand === Monitech ? "monitechiid" : brand,
              silent: true,
            };

            const message = await enrolleeService.sendVerifyCode(emailObj);

            toast.success(t("toasts.updateComplete"));

            sessionStorage.removeItem("googleMapData");
            sessionStorage.removeItem("appointmentData");
            sessionStorage.removeItem("appointmentCreatedFlag");
            sessionStorage.removeItem("clientProfiles");
            sessionStorage.removeItem("locationVehicleConfirmed");
            sessionStorage.removeItem("locationResumeStateInfoAfterVehicle");
            sessionStorage.removeItem("forceLocationZipAfterVehicle");
            sessionStorage.removeItem(LOCATION_PROGRAM_INFO_COMPLETED_KEY);
            sessionStorage.removeItem("enrolleeUser");
            sessionStorage.removeItem(LOCATION_WELCOME_ENTRY_KEY);

            cookies.remove("lifesaferUser", { path: "/" });

            window.location.href = `${process.env.CP_URL}/account/transfer/${message}-${enrolleeUser?.userId}-${enrolleeUser?.clientId}`;
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(t("toasts.updateFailed") + " " + errMess);
          } finally {
            setSubmitting(false);
          }
          break;
        default:
          console.warn(`Unknown step "${currentStep}"`);
      }
      hasSetInitialStep.current = true;
      if (
        !(
          currentStep === "Contact" &&
          !hasUsableEnrollmentCode(enrollmentCodeData)
        )
      ) {
        setIsEnrolleeLoadNeeded(true);
      }
      if (currentStep === "Contact" && shouldSkipNextStep) {
        return;
      }
      if (!shouldSkipNextStep) {
        // goToNextStep();
      }
      if (
        currentStep !== "Contact" &&
        !shouldSkipNextStep &&
        updateData?.isReferralModalSubmit
      ) {
        goToNextStep();
      }
    } catch (error) {
      let errMess = error.message
        ?.split(":")
        .pop()
        ?.replace('"', "")
        ?.slice(0, -2);
      toast.error(t("toasts.updateFailed") + " " + errMess);
    } finally {
      setSubmitting(false);
    }
    if (updateData?.isReferralModalSubmit) {
      setReferralModal(false);
    } else if (currentStep === "Vehicle") {
      dismissLocationWelcome();
      const pendingAppointment = getPendingAppointmentData();
      const hasPendingLocationReservation =
        hasReservedPendingLocationAppointment(pendingAppointment);
      if (
        hasPendingLocationReservation &&
        (resumeStateInfoAfterVehicle ||
          sessionStorage.getItem("locationResumeStateInfoAfterVehicle") ===
            "true")
      ) {
        sessionStorage.removeItem("locationResumeStateInfoAfterVehicle");
        setResumeStateInfoAfterVehicle(false);
        setActiveStep(locationStepIndexMap.Violation);
      } else {
        sessionStorage.removeItem("locationResumeStateInfoAfterVehicle");
        setResumeStateInfoAfterVehicle(false);
        if (!locationIdFromCookie) {
          const currentEnrollee =
            JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
          sessionStorage.setItem(
            "enrolleeUser",
            JSON.stringify({
              ...currentEnrollee,
              deviceType:
                deviceLocationType || currentEnrollee?.deviceType || null,
              step: "Schedule",
              Step: "Schedule",
              story: "Location",
              Story: "Location",
            }),
          );
          sessionStorage.setItem("forceLocationZipAfterVehicle", "true");
          setFlagDevice(true);
          setStepSchedule(STEPS.LOCATION_ZIP);
        }
        setActiveStep(locationStepIndexMap.Schedule);
      }
    } else if (currentStep === "Schedule") {
      setActiveStep(
        hasResolvedLocationProgramInfo
          ? locationStepIndexMap.StateId
          : locationStepIndexMap.Violation,
      );
    } else if (currentStep === "Violation") {
      const submittedDeviceType = resolveDeviceTypeValue(
        updateData?.deviceType,
        deviceLocationType,
        enrolleeUser?.deviceType,
      );
      setActiveStep(
        hasExistingLocationReservation() ||
          submittedDeviceType === "Portable"
          ? locationStepIndexMap.StateId
          : locationStepIndexMap.Vehicle,
      );
    } else if (currentStep !== "Contact") {
      goToNextStep();
    }
  };

  const welcomeSteps = [
    {
      title: t("location.welcomeTitleThree"),
      description: isPam
        ? t("location.welcomeDescriptionThreePam")
        : t("location.welcomeDescriptionThree"),
    },
    {
      title: t("partner.welcomeStepTitleTwo"),
      description: t("location.welcomeTitleFourDescription", {
        serviceCenterName: location?.displayName,
      }),
    },
    {
      title: t("location.welcomeTitleFive"),
      description: t("location.welcomeTitleFiveDescription"),
    },
  ];

  const Welcome = () => {
    return (
      <Grid
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: isMobile ? 0 : 2,
          flexDirection: "column",
          padding: isMobile ? "24px" : "0px",
          paddingTop: isMobile ? "0px" : "auto",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            flexDirection: "column",
            // textAlign: "center",
            textAlign: { xs: "left", sm: "center" },
            gap: "4px",
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#4B9CD3",
            }}
          >
            {t("location.welcomeHeading", {
              serviceCenterName: location?.displayName,
            })}
            <br />
          </Typography>
          <Typography>{t("location.welcomeTitleOne")}</Typography>
        </Grid>

        <Grid
          sx={{
            marginTop: "24px",
            marginLeft: "8px",
            width: "fit-content",
          }}
        >
          <Grid>
            <Typography
              sx={{
                marginBottom: 2,
                fontWeight: "bold",
              }}
            >
              {t("location.welcomeTitleTwo")}
            </Typography>
          </Grid>

          {welcomeSteps.map((step, index) => (
            <Grid
              key={index}
              sx={{
                display: "flex",
                gap: "12px",
                marginBottom: "16px",
              }}
            >
              <TaskAltIcon sx={{ color: "#75BE43" }} />
              <Box>
                <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
                  {step.title}
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "14px" }}
                >
                  {step.description}
                </Typography>
              </Box>
            </Grid>
          ))}

          <Grid sx={{ mt: 5, width: "100%" }}>
            <ContinueButton
              onClick={dismissLocationWelcome}
              continueText={t("location.scheduleMyAppointment")}
              submitting={submitting}
              continueButtonShow
              isFullLeftRightWidth
              showForwardIcon={false}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const handleBeforeLocationSelection = useCallback(() => {
    if (hasActiveLocationReservation) {
      setActiveStep(
        hasResolvedLocationProgramInfo
          ? locationStepIndexMap.StateId
          : locationStepIndexMap.Violation,
      );
      return;
    }

    const requiresProgramInfo =
      !hasResolvedLocationProgramInfo &&
      !hasUsableEnrollmentCode(cookies.get("lsEnrollmentCode"));

    if (requiresProgramInfo) {
      setActiveStep(
        jwtTokenData?.jwtToken
          ? locationStepIndexMap.Violation
          : locationStepIndexMap.Contact,
      );
      return;
    }

    if (isPamForLocation || vehicleReadyForLocation) return;

    if (!jwtTokenData?.jwtToken) {
      setActiveStep(locationStepIndexMap.Contact);
      return;
    }

    setActiveStep(locationStepIndexMap.Vehicle);
  }, [
    hasActiveLocationReservation,
    hasResolvedLocationProgramInfo,
    isPamForLocation,
    jwtTokenData?.jwtToken,
    locationStepIndexMap.Contact,
    locationStepIndexMap.StateId,
    locationStepIndexMap.Violation,
    locationStepIndexMap.Vehicle,
    setActiveStep,
    vehicleReadyForLocation,
  ]);

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <>
            {shouldShowLocationWelcome ? (
              <Grid sx={{ display: "flex", justifyContent: "center" }}>
                <Welcome />
              </Grid>
            ) : (
              <LocationSchedule
                setActiveStep={setActiveStep}
                handleUpdate={handleUpdate}
                submitting={submitting}
                setDeviceLocationType={setDeviceLocationType}
                deviceLocationType={deviceLocationType}
                isLoaded={isLoaded}
                goToBackStep={null}
                STEPS={STEPS}
                stepSchedule={stepSchedule}
                setStepSchedule={setStepSchedule}
                setGoogleMapData={setGoogleMapData}
                flagDevice={flagDevice}
                setFlagDevice={setFlagDevice}
                googleMapDataSession={googleMapDataSession}
                flagClickReset={flagClickReset}
                deviceCheck={deviceCheck}
                canEnterLocationSelection={
                  hasResolvedLocationProgramInfo &&
                  (isPamForLocation || vehicleReadyForLocation)
                }
                onBeforeLocationSelection={handleBeforeLocationSelection}
                // pricing
                // forceLocationSelectionEachEntry
              />
            )}
          </>
        );

      case 1:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <ContactInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                contactInfoForm={contactInfoForm}
                pereferedContact={pereferedContact}
                setPreferedContact={setPreferedContact}
                handleUpdate={handleUpdate}
                stepSchedule={stepSchedule}
                setStepSchedule={setStepSchedule}
                STEPS={STEPS}
                deviceLocationType={deviceLocationType}
                // isLoaded={isLoaded}
              />
            </Grid>
          </>
        );
      case 2:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <ViolationInfo
                submitting={submitting}
                handleUpdate={handleUpdate}
                setSubmitting={setSubmitting}
                goToBackStep={goToBackStep}
                setIsPam={setIsPam}
              />
            </Grid>
          </>
        );

      case 3:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <VehicleInfos
                setSubmitting={setSubmitting}
                submitting={submitting}
                deviceType={deviceLocationType}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
                goToNextStep={goToNextStep}
              />
            </Grid>
          </>
        );
      case 4:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <StateId
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
                goToNextStep={goToNextStep}
              />
            </Grid>
          </>
        );
      case 5:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <AddressInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
                userData={userData}
              />
            </Grid>
          </>
        );
      case 6:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <MyAccount
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
                appointments={appointmentData}
              />
            </Grid>
          </>
        );

      default:
        <>No component</>;
    }
  };

  // return <>{renderStepContent(activeStep)}</>;

  return (
    <>
      {pageLoading && (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <RingLoader />
        </Box>
      )}
      {showToastOverlay && (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1200,
          }}
        />
      )}
      <ReferralModal
        setReferralModal={setReferralModal}
        referralModal={referralModal}
        goToNextStep={goToNextStep}
        handleUpdate={handleUpdate}
        pereferedContact={pereferedContact}
        STEPS={STEPS}
        setStepSchedule={setStepSchedule}
        setActiveStep={setActiveStep}
        setFlagDevice={setFlagDevice}
        handleReferalSubmit={handleReferalSubmit}
        hideLocationWelcome={dismissLocationWelcome}
      />
      <Dialog
        open={deviceChangeModalOpen}
        onClose={handleCancelDeviceReschedule}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontSize: "18px", fontWeight: 600, pb: 1 }}>
          {t("location.deviceUpdateMadeTitle")}
        </DialogTitle>
        <DialogContent sx={{ pt: "0 !important" }}>
          <Typography sx={{ fontSize: "18px", lineHeight: 1.35 }}>
            {t("location.deviceUpdateMadeDescription")}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            pb: 3,
            pt: 2,
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 2,
          }}
        >
          <Button
            variant="contained"
            onClick={handleConfirmDeviceReschedule}
            size="small"
            sx={{
              backgroundColor: "#76BC21",
              color: "#1c355e",
              fontWeight: 700,
              borderRadius: "4px",
              minHeight: 44,
              px: 4,
              "&:hover": {
                backgroundColor: "#6aa81d",
              },
            }}
          >
            {t("location.confirmAppointment")}
          </Button>
          <Button
            variant="text"
            onClick={handleCancelDeviceReschedule}
            size="small"
            sx={{
              color: "#2f5558",
              fontWeight: 700,
              ml: 2,
            }}
          >
            {t("location.cancel")}
          </Button>
        </DialogActions>
      </Dialog>
      {stepsInfo[activeStep] &&
        activeStep > 0 &&
        stepsInfo[activeStep].progressBarValue !== null &&
        stepsInfo[activeStep].progressBarValue !== undefined &&
        !shouldShowLocationWelcome && (
          <Grid
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Box
              sx={{
                position: "relative",
                width: isAbove1024 ? "80%" : "100%",
                // mt: 2,
              }}
            >
              <BorderLinearProgress
                variant="determinate"
                value={stepsInfo[activeStep].progressBarValue}
                // color="success"
                sx={{ height: isAbove1024 ? "36px" : "25px", borderRadius: 10 }}
              />
              <Typography
                variant="body2"
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: {
                    // xs: `${stepsInfo[activeStep].progressBarValue - 4}%`,
                    // sm: `${stepsInfo[activeStep].progressBarValue - 1.4}%`,
                    xs: `${
                      stepsInfo[activeStep].progressBarValue - (isPam ? 4 : 6)
                    }%`, // Mobile
                    sm: `${
                      stepsInfo[activeStep].progressBarValue -
                      (isPam ? 2.5 : 4.5)
                    }%`, // Small tablets (600px+)
                    md: `${
                      stepsInfo[activeStep].progressBarValue -
                      (isPam ? 1.4 : 1.8)
                    }%`, // Tablets/Laptops (900px+)
                  },
                  transform: "translate(-50%, -50%)",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  color: "white",
                }}
              >
                {stepsInfo[activeStep].icon}
              </Typography>
            </Box>
          </Grid>
        )}

      {stepsInfo[activeStep] && (
        <StepsHeader
          title={stepsInfo[activeStep].title}
          description={stepsInfo[activeStep].description}
        />
      )}

      {renderStepContent(activeStep)}
    </>
  );
};

const mapDispatchToProps = {
  enrolleeUpdate,
  clientUpdate,
  registerEnrollee,
  saveEnrollee,
  loadEnrollee,
  saveNewVehicle,
  loadVehicle,
  clientProfiles,
  createAppointment,
  loadAppointments,
  loadLocation,
};

function mapStateToProps() {
  return {
    // appointments: state.appointments,
  };
}

LocationStory.propTypes = {
  enrolleeUpdate: PropTypes.func,
  clientUpdate: PropTypes.func,
  registerEnrollee: PropTypes.func,
  setActiveStep: PropTypes.func,
  saveEnrollee: PropTypes.func,
  isLoaded: PropTypes.bool,
  onClick: PropTypes.func,
  loadEnrollee: PropTypes.func,
  seconds: PropTypes.string,
  activeStep: PropTypes.number,
  hasSetInitialStep: PropTypes.bool,
  saveNewVehicle: PropTypes.func,
  loadVehicle: PropTypes.func,
  clientProfiles: PropTypes.func,
  appointments: PropTypes.object,
  createAppointment: PropTypes.func,
  loadAppointments: PropTypes.func,
  loadLocation: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationStory);
